// import axios from "axios";
// import protobuf from "protobufjs";
// import firebaseConfigProto from "../protocol/firebase_config.proto";

// const root = await protobuf.load(firebaseConfigProto);
// const FirebaseConfig = root.lookupType("FirebaseConfig");
// let buffer ;

// try {
//   const response = await axios.get(
//     `${process.env.REACT_APP_GETCONFIG_API_URL}/config/getConfig`,
//     {
//       responseType: "arraybuffer",
//     }
//   );
//   buffer = new Uint8Array(response.data);

//   for (let i = 0; i < buffer.length; i++) {
//     buffer[i] = buffer[i] ^ 0xaa; // Use the same value as before
//   }
// } catch (error) {}

// const firebaseConfig = FirebaseConfig.decode(buffer);

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIRE_BASE_API_KEY,
  authDomain: process.env.REACT_APP_FIRE_BASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIRE_BASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIRE_BASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIRE_BASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIRE_BASE_APP_ID,
  measurementId: process.env.REACT_APP_FIRE_BASE_MESSAGING_SENDER_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };